import user from './user';
import auth from './auth'
import appointment from './appointment';

export default {
  user,
  auth,
  appointment, 
};



// WEBPACK FOOTER //
// ./src/redux-modules/modules/index.js